import React from 'react';
import { Switch } from '@material-ui/core';
import { useMutation, useNotify } from 'react-admin';

// Inline "Sửa đơn" toggle for the Agency Employee list. Reuses console.User/EditUser
// (no new API) - but EditUser is a full-record overwrite, not a true partial update
// (every field it knows about is unconditionally re-set from the request), so the
// payload here must carry the complete current record, not just {id, allow_edit_order}.
// Every field EditUser writes (name, avatar, phone_number, birth_day, sex, group,
// address, basic_salary, latitude, longitude, status) is already present on the list
// row's record (see toPbUser/ListUser on the backend), so spreading `record` is both
// safe and sufficient - nothing gets silently blanked out.
const AllowEditOrderField = (props) => {
    const { record = {}, resource } = props;
    const notify = useNotify();
    const [mutate] = useMutation();

    const [checked, setChecked] = React.useState(!!record.allow_edit_order);
    const [loading, setLoading] = React.useState(false);

    // Keep in sync if the underlying record changes from elsewhere (e.g. a refresh).
    React.useEffect(() => {
        setChecked(!!record.allow_edit_order);
    }, [record.allow_edit_order]);

    const handleChange = (event) => {
        const newValue = event.target.checked;
        const previousValue = checked;

        setChecked(newValue);
        setLoading(true);

        mutate(
            {
                type: 'update',
                resource,
                payload: {
                    id: record.id,
                    data: { ...record, allow_edit_order: newValue },
                    previousData: record,
                },
            },
            {
                onSuccess: () => {
                    setLoading(false);
                    notify('Đã cập nhật quyền sửa đơn', 'info');
                    // No refresh() here on purpose: the mutation already sent exactly the
                    // value now shown, so local `checked` state is already authoritative -
                    // refetching the whole list just to re-confirm it caused every row to
                    // re-render at once (visible as a flicker) for no benefit. A real page
                    // reload still shows the persisted value, independently of this.
                },
                onFailure: (error) => {
                    setLoading(false);
                    setChecked(previousValue);
                    notify(`Error: ${(error && error.message) || 'Không thể cập nhật'}`, 'warning');
                },
            }
        );
    };

    return (
        <Switch
            checked={checked}
            onChange={handleChange}
            disabled={loading}
            color="primary"
            onClick={(e) => e.stopPropagation()}
        />
    );
};

export default AllowEditOrderField;
